import {
  gatewayMapper,
  allBluetoothDevices,
  allGatewayDevices,
} from '../../../../pages/Device/constants';
import { DeviceModels, MedisanteDevice } from '../../../../pages/Device/types';
import { onlyUnique } from '../../../../utils/helpers';

export const getGatewayId = (devices: MedisanteDevice[]) => {
  const allAreBTDevices = devices.every((d) =>
    allBluetoothDevices.includes(d.model as DeviceModels)
  );
  const allAreGatewayDevices = devices.every((d) =>
    gatewayMapper.some((m) => m.gatewayModel.includes(d.model as DeviceModels))
  );

  if (allAreGatewayDevices && devices.length === 1) {
    return devices[0].id;
  } else if (allAreBTDevices && devices.some((d) => !!d.gatewayID)) {
    return devices.find((d) => !!d.gatewayID)!.gatewayID!;
  } else {
    return null;
  }
};

export const getBTDevices = (devices: MedisanteDevice[]) => {
  const allAreBTDevicesWithSameGateway = devices.every(
    (d) =>
      d.gatewayID === devices[0].gatewayID &&
      allBluetoothDevices.includes(d.model as DeviceModels)
  );

  const allAreBTDevicesWithSameGatewayModel =
    allAreBTDevicesWithSameGateway &&
    devices
      .map(
        (d) =>
          gatewayMapper.find((g) =>
            g.bluetoothModels.includes(d.model as DeviceModels)
          )!.gatewayModel
      )
      .every((gm, i, arr) => gm === arr[0]);

  return allAreBTDevicesWithSameGatewayModel ? devices : [];
};

export const getSelectedGatewayIds = (devices: MedisanteDevice[]) => {
  return devices
    .filter((d) => allGatewayDevices.includes(d.model as DeviceModels))
    .map((g) => g.id);
};

export const getSensorsGatewaysIds = (devices: MedisanteDevice[]) => {
  return devices
    .filter(
      (d) =>
        allBluetoothDevices.includes(d.model as DeviceModels) && !!d.gatewayID
    )
    .map((d) => d.gatewayID!);
};

export const getAllGatewayIds = (devices: MedisanteDevice[]) => {
  const selectedGatewayIds = getSelectedGatewayIds(devices);

  const sensorsGatewaysIds = getSensorsGatewaysIds(devices);

  const gatewayIds = [...selectedGatewayIds, ...sensorsGatewaysIds].filter(
    onlyUnique()
  );

  return gatewayIds;
};

export const getSelectedSensors = (selectedDevices: MedisanteDevice[]) => {
  return selectedDevices.filter(
    (d) =>
      allBluetoothDevices.includes(d.model as DeviceModels) && !!d.gatewayID
  );
};

export const getGatewaySensors = (gateways: MedisanteDevice[]) => {
  return gateways
    .map((g) => g.sensors || ([] as MedisanteDevice[]))
    .reduce((sum, sensors) => [...sum, ...sensors], []);
};

export const getSensors = (
  selectedDevices: MedisanteDevice[],
  gateways: MedisanteDevice[]
) => {
  const selectedSensors = getSelectedSensors(selectedDevices);

  const gatewaySensors = getGatewaySensors(gateways);

  return [...selectedSensors, ...gatewaySensors].filter(
    onlyUnique((s1, s2) => s1.id === s2.id)
  );
};
